import React from "react";
import { useLocation } from "react-router-dom";
import { onSidebarSelection } from "src/components/Form/helper";
import { GasOptionEnum } from "src/components/Form/types";
import FormContext from "src/context/FormContext";

export const useSidebarSection = () => {
  const location = useLocation();
  const isClaim = location.hash.includes("claim");
  const {
    visibleBlocks,
    formState: {
      address,
      state,
      postcode,
      electricityService,
      gasServices,
      internetService,
    },
    requestDetailsLoaded,
    sidebarStatus,
  } = React.useContext(FormContext);

  // Helper functions to get journeyId and requestId
  const getElectricityIds = () => ({
    journeyId: electricityService?.journeyId,
    requestId: electricityService?.requestId,
    distributorApplicationId: electricityService?.distributorApplicationId,
  });

  const getGasIds = (gasType: GasOptionEnum) => ({
    journeyId: gasServices?.[gasType]?.journeyId,
    requestId: gasServices?.[gasType]?.requestId,
  });
  const getInternetIds = () => ({
    journeyId: internetService?.journeyId,
    requestId: internetService?.requestId,
  });

  // Example usage - you can use these anywhere in the component
  const electricityIds = getElectricityIds();
  const gasLineIds = getGasIds(GasOptionEnum.GAS_LINE);
  const gasMeterIds = getGasIds(GasOptionEnum.GAS_METER);
  const gasBothIds = getGasIds(GasOptionEnum.BOTH);
  const internetIds = getInternetIds();

  const selectSidebarItem = (
    blockRef: React.RefObject<HTMLDivElement> | undefined
  ) => {
    if (blockRef) {
      onSidebarSelection(blockRef);
    }
  };
  return {
    isClaim,
    visibleBlocks,
    address,
    state,
    postcode,
    electricityService,
    gasServices,
    requestDetailsLoaded,
    sidebarStatus,
    electricityIds,
    gasLineIds,
    gasMeterIds,
    gasBothIds,
    internetIds,
    selectSidebarItem,
  };
};
